export const en = {
    'default-tab-name': 'Default',
    'idea-tab-name': 'Images from page',
    'recently-used-tab-name': 'Recently used'
};
